import Vue from 'vue'

export const store = Vue.observable({
  haveResults: false,
  isLoading:false,
  initialStatus: true,
  documents: [],
  searchListVisible: true,
  filters: {
    employeeStatus: 'active'
  },
  foldersItems: [],
  eforms: [],
  pagination: {
    rows: 20,
    page: 1
  },
  total: '',
  pageCount: 0,
  orderBy: 'id',
  orderType: 'desc',
  history: {
    params: {}
  }
})

export const mutations = {
  setHaveResults(status) {
    store.haveResults = status
  },

  setIsLoading(value) {
    store.isLoading = value
  },

  setSearchListVisible(value) {
    store.searchListVisible = value
  },

  setDocuments(documents) {
    store.documents = documents
  },

  setInitialStatus(status) {
    store.initialStatus = status
  },
  setFilters(filters) {
    store.filters = { ...filters }
  },
  setFoldersItems(items) {
    store.foldersItems = items
  },
  setResultsEforms(eforms) {
    store.eforms = eforms
  },
  setOrderBy(orderBy) {
    store.orderBy = orderBy
  },
  setOrderType(orderType) {
    store.orderType = orderType
  },
  setPagination(pagination) {
    store.pagination = pagination
  },
  setTotal(total) {
    store.total = total
  },
  setPageCount(pageCount) {
    store.pageCount = pageCount
  },
  setHistoryParams(history) {
    store.history = Object.assign(store.history, { params: { ...history } })
  },
  setHistory(history) {
    store.history = history
  },
  clearFilters() {
    store.filters = {
      employeeStatus: 'active'
    }
  }
}
